import { products } from "@/api";

/* eslint no-param-reassign: ["error"] */
const currentState = {
  activeProducts: [],
  bookableProducts: [],
  activeProductsNotGrouped: [],
  inactiveProducts: [],
};

const mutations = {
  set_products(state, { activeProducts, inactiveProducts, bookableProducts }) {
    state.activeProducts = activeProducts;
    state.inactiveProducts = inactiveProducts;
    state.bookableProducts = bookableProducts;
  },
};

const actions = {
  async getProducts({ commit, rootState }, code) {
    try {
      const res = await products.variations.all(null, {
        filter: { supplier_id: rootState.auth.user.supplier.id, pagination: 0 },
      });

      commit("set_products", {
        activeProducts: res.data().filter((p) => p.status === 1),
        bookableProducts: res.data().filter((p) => p.status === 2),
        inactiveProducts: res.data().filter((p) => p.status === 0),
      });

      return data;
    } catch ({ response }) {}
  },
};

const getters = {
  activeProducts: (state) => state.activeProducts,
  inactiveProducts: (state) => state.inactiveProducts,
  bookableProducts: (state) => state.bookableProducts,
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
